import { IslandType } from '../../../islands/enums';
import { ActionRuleParams } from '../../types';
import { syncPromotionalSkuCount } from '../../helpers';

import type { CornerSize } from '../../../islands/types';
import type { Island } from '../../../islands/island.class';
import type { Kitchen } from '../../../kitchens/kitchen.class';

const STANDARD_DEFAULT_DEPTH = 28;
const SKU = 'CUSTOM_ISLANDDEPTH_INCREASE';

// MOK islands are their own standard size — depth deviations must not trigger a custom-depth charge.
const isMokIsland = (island: Island, kitchen: Kitchen): boolean => {
	const surroundKey = island.surround?.key ?? kitchen.material?.surround?.key ?? '';
	return surroundKey.toLowerCase().startsWith('mok');
};

const isDepthIncreased = (island: Island, kitchen: Kitchen): boolean => {
	if (isMokIsland(island, kitchen)) return false;

	const { size, type } = island;

	if (type === IslandType.Corner) {
		const { depth } = size as CornerSize;
		return depth.left > STANDARD_DEFAULT_DEPTH || depth.right > STANDARD_DEFAULT_DEPTH;
	}

	return (size.depth as number) > STANDARD_DEFAULT_DEPTH;
};

export const islandDepthIncrease = (params: ActionRuleParams): void => {
	const { refMap } = params;
	const { kitchen } = refMap;
	if (!kitchen) return;

	const islands = refMap.islands ?? kitchen.design?.islands ?? null;
	if (!islands) return;

	const qualifyingCount = islands.children.filter((island) => isDepthIncreased(island as Island, kitchen)).length;

	syncPromotionalSkuCount({ kitchen, sku: SKU, qualifyingCount });
};
